import { ProductionListItem } from './groupProductionLists'

export interface ProductionListToReprint {
  date: string
  productionListItems: ProductionListItem[]
  orderNo?: string | string[]
  orderId?: string
}

const getReprintStatusProductionLists = (productionLists: ProductionListItem[][], userId: string): ProductionListToReprint[] => {
  const productionListsWithOrderHistory = productionLists
    .map((list) => list.filter((order) => {
      return order.groupedOrders?.filter(product =>
        product.orders?.find(orderItem =>
          orderItem.orderHistory && orderItem.orderHistory.length > 0
        )
      ).length > 0
    })).filter(group => group.length > 0)

  return productionListsWithOrderHistory.reduce((acc, list) => {
    list.forEach((order) => {
      order.groupedOrders.forEach((product) => {
        product.orders.forEach((subOrder) => {
          const orderLastChanged = subOrder.orderHistory?.[0]?.date
          subOrder.printedByUsersWithType?.forEach((printedByUser) => {
            if (userId === printedByUser.userId && orderLastChanged) {
              const printAction = printedByUser.actions.find(action => action.type === "ProductionList")
              if (printAction && printAction.printedDateTime < orderLastChanged) {

                const productionListWithUpdatedOrders = {
                  date: order.deliveryDate,
                  productionListItems: [order],
                  orderNo: subOrder.orderNumber,
                  orderId: subOrder.orderId
                }
                const listString = JSON.stringify(productionListWithUpdatedOrders)
                if (!acc.uniqueSet.has(listString)) {
                  acc.uniqueSet.add(listString)
                  acc.listsToReprint.push(productionListWithUpdatedOrders)
                }
              }
            }
          })
        })
      })
    })
    return acc
  }, {
    uniqueSet: new Set(),
    listsToReprint: [] as ProductionListToReprint[],
  }).listsToReprint
}

export default getReprintStatusProductionLists